<template>
  <v-dialog v-model="showModal" max-width="1100px" persistent>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-card v-else>      
        <v-toolbar dark class="primary">
          <v-btn icon @click.native="showModal = false" dark>
            <v-icon>fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>                    
        </v-toolbar>                
        <v-card-text>
        <v-progress-linear :indeterminate="true" v-if="saving"></v-progress-linear>          
        <v-form :class="visibility_class" @submit="handleSubmit">
          <v-container fluid  grid-list-xl>
            <v-layout row wrap>
              <v-flex xs6>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field label="Nazwa użytkownika*" v-validate="'required'" name="userName" id="userName" :error-messages="errors.collect('userName')" data-vv-as="Nazwa użytkownika" v-model="userName"></v-text-field>                 
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field label="Adres email*" v-validate="'required|email'" data-vv-as="Adres email" name="emailAddress" id="emailAddress" :error-messages="errors.collect('emailAddress')"  v-model="emailAddress"></v-text-field>
                  </v-flex>    
                  <v-flex xs6>
                    <v-text-field label="Imię*" v-validate="'required'" data-vv-as="Imię" name="name" id="name" :error-messages="errors.collect('name')"   v-model="name"></v-text-field>
                  </v-flex>  
                  <v-flex xs6>
                    <v-text-field label="Nazwisko*" v-validate="'required'" data-vv-as="Nazwisko" id="surname" name="surname" :error-messages="errors.collect('surname')"  v-model="surname"></v-text-field>
                  </v-flex>                 
                  <v-flex d-flex xs12 v-if="id == 0">
                    <v-layout row wrap>
                    <v-flex  xs6 >
                      <v-text-field label="Hasło*" v-validate="'required'" name="password" id="password"  data-vv-as="Hasło" :error-messages="errors.collect('password')" v-model="password" ref="password" :type="'password'" :append-icon="'fa-eye-slash'"></v-text-field>
                    </v-flex>
                    <v-flex   xs6>
                      <v-text-field label="Powtórz hasło*" v-validate="'confirmed:password'" name="password_confirmation" id="password_confirmation" :error-messages="errors.collect('password_confirmation')"  :append-icon="'fa-eye-slash'"  data-vv-as="'powtórz hasło'"  :type="'password'"></v-text-field>
                    </v-flex>       
                    </v-layout>       
                  </v-flex>
                  <v-flex >
                    <v-checkbox
                      v-model="isactive"
                      label="Aktywny?"
                    ></v-checkbox>

                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout row wrap>
                  <v-flex xs12 v-if="roleNames != null && roleNames.length > 0">
                    <h3>Przypisane role</h3>
                    <v-list>
                      <v-list-item v-for="(item,index) in roleNames" :key="index">
                        <v-list-item-content>
                          {{item}}
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-icon small @click="removeRole(item)" title="Usuń role">fa-trash-alt</v-icon>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 v-if="avaibleRoles != null && avaibleRoles.length > 0">
                    <v-layout row wrap>
                      <v-flex xs8>
                        <v-select :items="avaibleRoles" label="Rola" placeholder="Wybierz role..." v-model="role" name="role" id="role">
                        </v-select>
                      </v-flex>           
                      <v-flex xs4>
                          <v-btn color="primary" @click="addRole">Dodaj rolę</v-btn>
                      </v-flex>            
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 v-if="additionalOutposts != null && additionalOutposts.length > 0" style="margin-top:30px">
                    <h3>Przypisane placówki</h3>
                    <v-list>
                      <v-list-item v-for="(item,index) in selectedAdditionalOutposts" :key="index">
                        <v-list-item-content>
                          {{item.name}}
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-icon small @click="removeAdditionalOutpost(item)" title="Usuń placówke">fa-trash-alt</v-icon>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-flex>
                  <v-flex xs12 v-if="additionalOutposts != null && additionalOutposts.length > 0">
                    <v-layout row wrap>
                      <v-flex xs8>
                        <v-select :items="availableOutposts" v-if="availableOutposts && availableOutposts.length > 0" label="Placówka" placeholder="Wybierz placówke..." item-text="name" v-model="additionalOutpost" name="role" id="role" return-object>
                        </v-select>
                      </v-flex>
                      <v-flex xs4>
                        <v-btn color="primary" @click="addAdditionalOutpost">Dodaj placówke</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>              
            </v-layout>
            <v-row>
              <v-col cols="12">
                <v-checkbox v-model="forceResetPasswordAtLogin" label="Wymuś zmiane hasła przy zalogowaniu"></v-checkbox>
                <v-checkbox v-model="forceSet2FAAtLogin" label="Wymuś ustawienie uwierzytelniania dwuskładnikowego przy zalogowaniu"></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        </v-card-text>
        <v-card-actions>
           <v-spacer></v-spacer>
          <v-btn @click="closeForm" color="error">Zamknij</v-btn>
          <v-btn color="success"   @click="handleSubmit">Zapisz</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
  

</template>

<script>
import { userService, roleService, settingsService } from "@/services/";
import swal from "sweetalert";

export default {
  name: "AddEditUser",
  data() {
    return {
      title: "Tworzenie nowego użytkownika",
      loading: false,
      saving: false,
      userName: null,
      emailAddress: null,
      name: null,
      surname: null,
      password: null,
      visibility_class: "row",
      roles: [],
      roleNames: [],
      role: "",
      additionalOutpost: null,
      additionalOutposts: [],
      selectedAdditionalOutposts: [],
      dropdown_initialized: false,
      forceResetPasswordAtLogin: false,
      forceSet2FAAtLogin: false,
      isactive: true
    };
  },
  props: ["id", "visible"],
  methods: {
    showError(close, text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {
        this.show();
        if (close) {
          this.$emit("close");
        }
      });
    },
    closeForm() {
      this.$emit("close");
    },
    removeRole(role) {
      this.roleNames = this.roleNames.filter(
        x => x.toLowerCase() != role.toLowerCase()
      );
      /*this.roles.push(role);*/
    },
    addRole() {
      this.roleNames.push(this.role);
      /*this.roles = this.roles.filter(
        x => x.toLowerCase() != this.role.toLowerCase()
      );*/
      this.role = "";
    },
    removeAdditionalOutpost(outpost) {
      this.selectedAdditionalOutposts = this.selectedAdditionalOutposts.filter(x=>x.id != outpost.id)
    },
    addAdditionalOutpost(){
      this.selectedAdditionalOutposts.push(this.additionalOutpost)
    },
    handleSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.roleNames == null || this.roleNames.length == 0) {
            this.showError(false, "Nie wybrano ról");
            return;
          }
          if (this.id == 0) {
            this.saveUser();
          } else {
            this.updateUser();
          }
        }
      });
    },
    hide() {
      this.visibility_class = "row scale-transition scale-out";
      this.saving = true;
    },
    show() {
      this.visibility_class = "row";
      this.saving = false;
    },
    saveUser() {
      this.hide();
      let outposts = []
      if(this.selectedAdditionalOutposts && this.selectedAdditionalOutposts.length > 0)
      {
        this.selectedAdditionalOutposts.forEach(elem => {
          outposts.push(elem.id)
        })
      }
      userService
        .create({
          userName: this.userName,
          name: this.name,
          surname: this.surname,
          emailAddress: this.emailAddress,
          password: this.password,
          isActive: this.isactive,
          roleNames: this.roleNames,
          additionalOutposts: outposts,
          forceResetPasswordAtLogin: this.forceResetPasswordAtLogin,
          forceSet2FAAtLogin: this.forceSet2FAAtLogin
        })
        .then(() => {
          this.show();
          this.closeForm();
        })
        .catch(resp => {
          if (
            resp.response != null &&
            resp.response.data != null &&
            resp.response.data.error != null
          ) {
            this.showError(false, resp.response.data.error.message);
          } else {
            this.showError(false, "Błąd zapisu użytkownika");
          }
        });
    },
    updateUser() {
      this.hide();
      let outposts = []
      if(this.selectedAdditionalOutposts && this.selectedAdditionalOutposts.length > 0)
      {
        this.selectedAdditionalOutposts.forEach(elem => {
          outposts.push(elem.id)
        })
      }
      userService
        .update({
          userName: this.userName,
          name: this.name,
          surname: this.surname,
          emailAddress: this.emailAddress,
          isActive: this.isactive,
          roleNames: this.roleNames,
          additionalOutposts: outposts,
          forceResetPasswordAtLogin: this.forceResetPasswordAtLogin,
          forceSet2FAAtLogin: this.forceSet2FAAtLogin,
          id: this.id
        })
        .then(() => {
          this.show();
          this.closeForm();
        })
        .catch(resp => {
          if (
            resp.response != null &&
            resp.response.data != null &&
            resp.response.data.error != null
          ) {
            this.showError(false, resp.response.data.error.message);
          } else {
            this.showError(false, "Błąd zapisu użytkownika");
          }
        });
    },
    clearUserData() {
      this.userName = null;
      this.name = null;
      this.surname = null;
      this.emailAddress = null;
      this.isactive = true;
      this.title = "Tworzenie nowego użytkownika";
      this.role = null;
      this.password = null;
      this.roleNames = [];
      this.forceResetPasswordAtLogin = false;
      this.forceSet2FAAtLogin = false;
    },
    async refreshAdditionalOutposts() {
      settingsService.getAdditionalOutpostsForDropdown().then(response => {
        this.additionalOutposts = response.data.result
      }).catch(() => {
        this.showError(true, "Nie można pobrać listy dodatkowych placówek.");
      })
    },
    refreshRoles() {
      roleService
        .getAllNoPagination()
        .then(response => {
          if (
            response.data != null &&
            response.data.result != null &&
            response.data.result.items != null
          ) {
            response.data.result.items.forEach(r => {
              this.roles.push(r.name);
            });
          } else {
            throw "error pobierania ról";
          }
        })
        .catch(() => {
          this.showError(true, "Nie można pobrać listy ról.");
        });
    },
    loadAllData() {
      const additionalOutpostResponse =  settingsService.getAdditionalOutpostsForDropdown()
      const rolesResponse = roleService.getAllNoPagination()
      this.loading = true;
      Promise.all([additionalOutpostResponse, rolesResponse]).then(results => {
        let roles = results[1].data.result.items
        roles.forEach(r=> {
          this.roles.push(r.name)
        })

        this.additionalOutposts = results[0].data.result

        if(this.id > 0)
        {
          this.loadUserData()
        }
        else
        {
          this.clearUserData()
          this.loading = false
        }


      }).catch(() => {
        this.showError(true, "Nie można pobrać danych.");
        this.loading = false
      })


    },
    loadUserData() {
      //this.loading = true;
      userService
        .getById(this.id)
        .then(resp => {
          if (resp.data != null && resp.data.result != null) {
            this.userName = resp.data.result.userName;
            this.name = resp.data.result.name;
            this.surname = resp.data.result.surname;
            this.emailAddress = resp.data.result.emailAddress;
            this.isactive = resp.data.result.isActive;
            this.title = "Edycja użytkownika: " + this.userName;
            this.forceResetPasswordAtLogin = resp.data.result.forceResetPasswordAtLogin;
            this.forceSet2FAAtLogin = resp.data.result.forceSet2FAAtLogin;
            if (
              resp.data.result.roleNames != null &&
              resp.data.result.roleNames.length > 0
            ) {
              this.roleNames = resp.data.result.roleNames;
              this.roleNames.forEach(x => {
                this.roles = this.roles.filter(
                  z => z.toLowerCase() !== x.toLowerCase()
                );
              });
              if(resp.data.result.additionalOutposts && resp.data.result.additionalOutposts.length > 0)
              {

                resp.data.result.additionalOutposts.forEach(elem => {
                  let itm = this.additionalOutposts.find(x=>x.id == elem)
                  if(itm != null)
                    this.selectedAdditionalOutposts.push(itm)
                })
              }
              //var el = this.roles.find(x=>x.toLowerCase() == resp.data.result.roleNames[0].toLowerCase())
              //this.role = el
            }
            this.loading = false;
          } else {
            throw "Error getting user";
          }
        })
        .catch(() => {
          this.showError(true, "Błąd pobierania użytkownika");
        });
    }
  },
  created() {
    //this.loading = true;
    //this.refreshRoles();
    //this.refreshAdditionalOutposts();
  },
  updated() {},
  computed: {
    showModal: {
      get: function() {
        if (!this.visible) {
          this.clearUserData();
          this.errors.clear();
        }
        return this.visible;
      },
      set: function(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    },
    avaibleRoles: function() {
        if(this.roleNames && this.roles)
        {
          return this.roles.filter(x=> !this.roleNames.find(z=> z == x))
        }        
        return this.roles
    },
    availableOutposts: function() {
      if(this.selectedAdditionalOutposts && this.additionalOutposts)
      {
        return this.additionalOutposts.filter(x=> !this.selectedAdditionalOutposts.find(z=> z.id == x.id))
      }
      return this.additionalOutposts
    }
  },
  watch: {
    id: {
      immediate: true,
      handler: function(newid) {
        if (newid > 0) {
          this.loadAllData();
        } else {
          this.clearUserData();
          this.errors.clear();
          this.loading = true
          this.loadAllData()
//          this.loadAdditionalData()
        }
      }
    }
  },
  components: {}
};
</script>

<style>
</style>
